import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import { useSelector } from 'react-redux';
import { getIsSubscribedToOffline } from '@selectors/subscription';
import Typography from 'aquilla/core/atoms/Typography';
import Paper from 'aquilla/core/atoms/Paper';
import BreadCrumbs from 'aquilla/core/molecules/Breadcrumbs';
import * as util from '@cont/EnrolledCourse/utils';

const Wrapper = styled(Paper)`
  grid-column: span 18;
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B} ${Spacings.SPACING_6B}
    ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    box-shadow: none;
    background-color: var(--color-base-0);
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
    width: 330px;
    margin: auto;
  }
`;

const Heading = styled(Typography)`
  margin-top: ${Spacings.SPACING_6B};
  color: var(--color-text-primary);
`;

const TopBlock = ({ label, goal, seeAllType }) => {
  const isOfflineSubscription = useSelector(
    getIsSubscribedToOffline(goal?.uid)
  );

  return (
    <Wrapper>
      <BreadCrumbs
        fragments={util.getEnrollmentBreadCrumbs(
          goal,
          !!isOfflineSubscription,
          seeAllType
        )}
      />
      <Heading variant="h2">{label}</Heading>
    </Wrapper>
  );
};

export default TopBlock;
TopBlock.propTypes = {
  label: PropTypes.string,
  goal: PropTypes.objectOf(PropTypes.any).isRequired,
  seeAllType: PropTypes.string.isRequired
};

TopBlock.defaultProps = {
  label: ''
};
